import { render, staticRenderFns } from "./cluesLogin.vue?vue&type=template&id=0cc37612&scoped=true"
import script from "./cluesLogin.vue?vue&type=script&lang=js"
export * from "./cluesLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc37612",
  null
  
)

export default component.exports